import { ActionType } from "../constants";
// import { setUserSession } from "../service/AuthService";
const initialState = {
  defaultSalaryIdx: 11,
  serverRefreshes: 0,
  selections: {
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
    7: [],
    8: [],
    9: [],
    important9: [],
    10: [],
    11: [],
    12: [],
    13: [],
    14: [],
    15: [],
    16: [],
    17: [],
  },
  schoolIds: [],
  schoolData: {},
};
export default (state = initialState, action) => {
  try {
    switch (action.type) {
      case ActionType.updateSchools:
        console.log("updateSchools", action.payload);
        return {
          ...state,
          // uniques only
          // schoolIds: [...state.schoolIds, ...action.payload.schoolIds]
          schoolIds: [
            ...new Set([...state.schoolIds, ...action.payload.schoolIds]),
          ],
          schoolData: {
            ...state.schoolData,
            ...action.payload.schoolData,
          },
        };
      case ActionType.deleteSchool:
        return {
          ...state,
          schoolIds: state.schoolIds.filter((id) => id !== action.payload),
          schoolData: {
            ...state.schoolData,
            [action.payload]: undefined,
          },
        };
      case ActionType.updateSurvey:
        return {
          ...state,
          selections: {
            ...state.selections,
            ...action.payload,
          },
        };
      case ActionType.updateSurveyFromServer:
        return {
          ...state,
          serverRefreshes: state.serverRefreshes + 1,
          selections: {
            ...state.selections,
            ...action.payload,
          },
        };
      case ActionType.updateDefaultSalaryIdx:
        return {
          ...state,
          defaultSalaryIdx: action.payload,
        };
      case ActionType.logout:
        return {
          ...initialState,
        };
      default:
        return state;
    }
  } catch (e) {
    console.log("authReducer error:", e);
  }
};
